module.exports = __webpack_public_path__ + "img/esa.5d019113.svg";